import React, { createContext, useContext, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Socket } from "socket.io-client";
import { selectUser } from "../../core/auth/authSlice";
import socketService from "../../core/socket/socket.service";
import { User } from "../../shared/models";

const WebSocketContext = createContext<Socket | undefined>(undefined);

export const WebSocketProvider = ({ children }: React.PropsWithChildren) => {
  const { actorId } = useSelector(selectUser) as User;

  const [socket, setSocket] = useState<Socket | undefined>(undefined);
  useEffect(() => {
    if (!actorId) {
      console.warn("WebSocketProvider: No actorId available");
      return;
    }

    let socketInstance = socketService.getSocket(actorId);

    if (!socketInstance) {
      console.warn("WebSocketProvider: Socket not found, attempting to connect...");
      socketInstance = socketService.connect(actorId, null);
    }

    console.log("WebSocketProvider: Socket instance", socketInstance?.connected ? "connected" : "not connected");
    setSocket(socketInstance);

    return () => {
      // Don't close the socket on unmount, it's managed by the service
      // socketInstance?.close();
    };
  }, [actorId]);

  return (
    <WebSocketContext.Provider value={socket}>
      {children}
    </WebSocketContext.Provider>
  );
};

export const useWebSocket = () => useContext(WebSocketContext);
